<template>
    <span :class="[$style['mds-field-error'], classObject, sizeClass]" :data-mds-version="version">
        <slot>{{ text }}</slot>
    </span>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsFieldError',
        props: {
            onDark: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: 'medium',
                validator(value) {
                    return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
                },
            },
            text: {
                type: String,
            },
            version: {
                type: String,
                default: `${name}-${version}`,
            },
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-field-error--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './field-error.scss';
</style>
